import { ValidatorFn, AbstractControl, ValidationErrors } from '@angular/forms';
import { ModifiedSessionDocumentInfo } from '../models';

export function totalPayableAmountSelection(): ValidatorFn {
  return (
    control: AbstractControl<ModifiedSessionDocumentInfo[]>,
  ): ValidationErrors | null => {
    const documents = control.value?.filter((x) => !x.isCreditMemo);

    if (control.value == null || documents.length === 0) {
      return null;
    }

    const validationError = { totalPayableAmount: true };
    const totalPayableAmount = documents
      .filter((x) => x.isPayable)
      .reduce((acc, doc) => acc + doc.payableAmount, 0);

    if (totalPayableAmount === 0) {
      return validationError;
    }

    return null;
  };
}
